module.exports = __webpack_public_path__ + "static/media/page_not_found.d32bb14f.svg";